"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _reactRouterDom = require("react-router-dom");
var _config = require("../../config");
var _Translations = require("react-platform-components/dist/Translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ForgotPasswordSuccess() {
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: "p-20 h-screen",
    item: true,
    container: true,
    justify: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: "p-12"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "mb-8",
    variant: "h4"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Reset success !",
    defaultMessage: "Reset success !"
  })), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "mb-8",
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "An email with instructions was sent to you",
    defaultMessage: "An email with instructions was sent to you"
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: _config.BASE_URL,
    className: "mt-8"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "button"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Login",
    defaultMessage: "Login"
  }))))));
}
var _default = ForgotPasswordSuccess;
exports.default = _default;